import React from "react";
import { Modal, Button } from "react-bootstrap";
import DataTableLayer from "../../components/DataTableLayer";
import LottieLoading from "../../components/child/LottieLoading";

const ModalHistory = ({ open, onClose, data , isLoading }) => {
  const columns = [
    {
      header:"Music Label Name",
      accessorKey:"music_label_name",
    },
    {
      header: "Status",
      accessorKey: "status_name",
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: ({ row }) => row.getValue("description") || "-",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
    {
      header:"telephone",
      accessorKey: "telephone",
    },
    {
      header: "City",
      accessorKey: "city_name",
    },
    {
      header: "Is Partner",
      accessorKey:"is_partner"
    },
    {
      header:"Is Deleted",
      accessorKey: "is_deleted"
    }
  ];

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      backdrop="static"
      size="xl"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Riwayat Perubahan Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DataTableLayer data={data} columns={columns} title="Riwayat" showButton={false} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Tutup
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalHistory;
